import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: ':bookingId',
    loadComponent: () =>
      import('./booking-page/booking-page.component').then(m => m.BookingPageComponent)
  },
   {
    path: ':bookingId/openrequest',
    loadComponent: () =>
      import('./booking-page/booking-page.component').then(m => m.BookingPageComponent)
  },
  {
    path: ':bookingId/openrequest/:openRequestId',
    loadComponent: () =>
      import('./booking-page/booking-page.component').then(m => m.BookingPageComponent)
  }
];
